export const eventBookingExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{
		label: 'Community',
		render: e => e?.hub?.name || '',
	},
	{
		label: 'Sanstha',
		render: e => e?.sansthaId?.name || '',
	},
	{
		label: 'User Name',
		render: e => (e?.userId ? `${e.userId.firstName || ''} ${e.userId.lastName || ''}`.trim() : ''),
	},
	{
		label: 'User Mobile',
		render: e => e?.userId?.mobile || '',
	},
	{
		label: 'Event Title',
		render: e => e?.event?.title || '',
	},
	{
		label: 'Payment Type',
		render: e => (e?.isOffline ? 'Offline' : 'Online'),
	},
	{
		label: 'Amount',
		render: e => e?.amount ?? '',
	},
	{
		label: 'Payment Mode',
		render: e => e?.paymentMode || '',
	},
	{
		label: 'Payment Reference No',
		render: e => e?.paymentRef || '',
	},
	{
		label: 'Payment Date',
		render: e => (e?.paymentDate ? new Date(e.paymentDate).toLocaleDateString('en-IN') : ''),
	},
	{
		label: 'Status',
		render: e => e?.status || '',
	},
]
